<template>
  <div class="modal-panel">
    <div class="modal-head">
      <h3 class="modal-title">{{ titulo }} membresía</h3>
      <p class="modal-sub">Define el nombre, duración y precio del plan</p>
    </div>

    <div class="modal-body">
      <v-form ref="form" v-model="formValido" lazy-validation class="dark-form">
        <div class="field">
          <label class="field-label">Nombre de la membresía</label>
          <v-text-field
            v-model="membresia.nombre"
            :rules="reglas"
            required
            hide-details="auto"
            placeholder="Ej. Mensual Hombre"
            outlined
            dense
            class="dark-input"
          ></v-text-field>
        </div>

        <div class="field">
          <label class="field-label">Días de duración</label>
          <v-text-field
            v-model="membresia.duracion"
            :rules="reglas"
            type="number"
            required
            hide-details="auto"
            placeholder="30"
            outlined
            dense
            class="dark-input"
          ></v-text-field>
        </div>

        <div class="field">
          <label class="field-label">Precio</label>
          <v-text-field
            v-model="membresia.precio"
            :rules="reglas"
            type="number"
            required
            hide-details="auto"
            placeholder="0.00"
            prefix="$"
            outlined
            dense
            class="dark-input"
          ></v-text-field>
        </div>
      </v-form>
    </div>

    <div class="modal-footer">
      <button class="btn-ghost" @click="cerrarDialogo">Cerrar</button>
      <button class="btn-primary" :disabled="!formValido" @click="registrar">
        Registrar
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormMembresia",
  props: ["membresia", "titulo"],

  data: () => ({
    formValido: false,
    reglas: [(value) => !!value || "Campo obligatorio"],
  }),

  mounted() {
    this.formValido = false
  },
  methods: {
    cerrarDialogo() {
      this.$emit("cerrado", false);
    },

    registrar() {
      this.$emit("registrar", this.membresia);
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

.modal-panel {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
  font-family: var(--font-body);
  color: var(--text-primary);
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: capitalize;
}

.modal-sub {
  font-size: 12.5px;
  color: var(--text-secondary);
  margin: 0;
}

.modal-body {
  padding: 24px;
}

.dark-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== Overrides para reskinear v-text-field (Vuetify) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
}

.dark-input >>> input::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-text-field__prefix {
  color: var(--text-tertiary) !important;
  font-weight: 600 !important;
  margin-right: 2px;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

.dark-input >>> .v-input__append-inner,
.dark-input >>> .v-input__icon {
  color: var(--text-tertiary) !important;
}

.dark-input.v-input--is-focused >>> .v-label,
.dark-input >>> .v-label {
  color: var(--text-tertiary) !important;
  font-size: 13px;
}

/* Quita las flechas del input number */
.dark-input >>> input[type="number"]::-webkit-outer-spin-button,
.dark-input >>> input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.dark-input >>> input[type="number"] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/Membresias/FormMembresia.vue